const getAzureSasToken = () => {
  const rawToken =
    process.env.REACT_APP_CONTAINER_SAS_TOKEN ||
    process.env.CONTAINER_SAS_TOKEN ||
    process.env.REACT_APP_SECRET_KEY_blob ||
    '';

  if (!rawToken) return '';
  return rawToken.startsWith('?') ? rawToken : `?${rawToken}`;
};

export default getAzureSasToken;
